// extracted by mini-css-extract-plugin
export var active = "_2w-9";
export var backButton = "_2w-8";
export var clone = "_2w-e";
export var collapseBar = "_2w-j";
export var collapseMode = "_2w-l";
export var collapsed = "_2w-n";
export var dragHandle = "_2w-c";
export var dropdownIcon = "_2w-g";
export var expanding = "_2w-m";
export var hidden = "_2w-v";
export var iconContainer = "_2w-p";
export var iconSwapper = "_2w-u";
export var navItem = "_2w-6";
export var navItemIcon = "_2w-f";
export var navProfile = "_2w-7";
export var notificationCountBadge = "_2w-i";
export var notificationDot = "_2w-q";
export var optionsContainer = "_2w-h";
export var primaryNav = "_2w-0";
export var primaryNavDivider = "_2w-t";
export var primaryNavResizeHandle = "_2w-2";
export var primaryNavResizing = "_2w-1";
export var primaryTab = "_2w-o";
export var primaryTabIconBox = "_2w-r";
export var secondaryNav = "_2w-3";
export var selected = "_2w-s";
export var settingsNav = "_2w-4";
export var settingsNavItems = "_2w-5";
export var show = "_2w-d";
export var sideNav = "_2w-k";
export var teamItem = "_2w-a";
export var userProfileItem = "_2w-b";